import { useNavigate, useParams } from 'react-router-dom';
import history from '../../common/history';
import React, { useEffect, useState, useCallback } from 'react';
import styled, { keyframes } from 'styled-components';
// import QrReader from 'react-web-qr-reader';
import { QrReader } from 'react-qr-reader';
import { useGetItemByTno } from '../../../interface/item';
import { useGetInoutHistSel, useGetInoutInfo, useSetInoutHist } from '../../../interface/inout';
import NaviText from '../../backoffice/common/NaviText';
import { Row } from '../../../styles/common';
import { Collapse, Drawer, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch, TextField } from '@mui/material';
import Button from '../../common/Button';
import theme from '../../../styles/theme';
import { useGetCodeList } from '../../../interface/common';
import CommonDataGrid from '../../common/CommonDataGrid';
import MobileMsgModal from '../../common/modal/MobileMsgModal';
import useSound from 'use-sound';
import { useQuery, useQueryClient } from 'react-query';
import { ITEM_STATUS } from '../../common/constants';
import FoldingBar from '../../common/FoldingBar';

const MainWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const DrawerInner = styled.div`
    max-height: calc(100vh - 7rem);
    overflow: auto;
    .selected {
        color: ${theme.color.secondary.red};
    }
`;

const QRWrapper = styled.div`
    width: calc(100% - 8rem);
    height: auto;
    section div {
        border: 0 !important;
        box-shadow: none !important;
    }

    video {
        border-radius: 25%;
    }

    border-radius: 25%;
`;
const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 0.9;
    }
`
const Fab = styled.div`
    position: fixed;
    right: 2.5rem;
    top: 5.5rem;
    border-radius: 50%;
    border: 0.8px solid ${theme.color.secondary.puppleB};
    width: 3.5rem;
    height: 3.5rem;
    background: ${theme.color.primary.pupple};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    opacity: 0.9;
    animation: ${fadeIn} 0.8s;
`;

const CheckForm = styled(FormControlLabel)`
    margin-left: -11px;
    margin-right: 0px;
`;

const CheckBox =  styled(Switch)`
    & .MuiSwitch-switchBase.Mui-checked {
        color: ${theme.color.secondary.red};
    }
    & .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
        background-color: ${theme.color.secondary.red};
    }
`;

const columns = [
    { field: 'id', headerName: '순번', width:40 },
    { field: 'cat_nm', headerName: '분류', width:80 },
    { field: 'lot_no', headerName: '표기번호', width:100 },
    { field: 'model_nm', headerName: '모델명', width:200 },
    { field: 'tno', headerName: '자산번호', width:140 },
    { field: 'status_nm', headerName: '자산상태', width:100 },
    { field: 'rid', headerName: '연계자산', width:100 },
]

const InControl = () => {

    // const delay = 500;
    const delay = 100;
    const queryClient = useQueryClient();

    const navigate = useNavigate();
    const param = useParams();

    const [listOpen, setListOpen] = useState(false)
    const [result, setResult] = useState('');
    const [msg, setMsg] = useState('');
    const [selectItem, setSelectItem] = useState();

    const [i_contents, setI_contents] = useState();
    const [i_descr, setI_descr] = useState();

    const [msgOpen, setMsgOpen] = useState(false)
    const [retMsg, setRetMsg] = useState('');

    const [sendList, setSendList] = useState([]);
    const [oRetSt, setORetSt] = useState({code:ITEM_STATUS.NORMAL});
    const [folding, setFolidng] = useState(false);

    const [autoIn, setAutoIn] = useState(false);

    const { data : user } = useQuery('USER', {});
    const { data: pItem, isSuccess} = useGetInoutInfo({sno:param.sno});
    const { data: itemInfo, refetch: itemRefetch,remove} = useGetItemByTno(result);
    const { data : ioRetStList} = useGetCodeList('io_ret_st');
    const { data : inoutHistList, isLoading: inoutHistLoading } = useGetInoutHistSel({sno:param.sno});
    const { mutate } = useSetInoutHist();

    const [normal] = useSound('/sound/normal.mp3');

    // const [deviceId, setDeviceId] = useState(null);

    useEffect(() => {
        return history.listen(() => {
            if (history.action === "POP") {
                remove();
                navigate(history.location.pathname,{state:{sno:param.sno}})
            }
        });
    }, [history]);

    useEffect(()=>{
        if(result && result.tid){
            normal();
            itemRefetch();
        }
    },[result])

    useEffect(()=>{
            if(itemInfo && itemInfo.length===0) {
                setMsg('등록되어있지 않은 자산입니다.')
            }else{
                setI_contents('');
                setI_descr('');
                setMsg('');
                (autoIn === true) && handleAddSendList();
            }
    },[itemInfo])

    useEffect(()=>{
        setAutoIn(false);
    },[oRetSt])

    // const handleDevices = useCallback(
    //     mediaDevices => {
    //         const frontCamera = mediaDevices.find(media => /front|user|selfie/i.test(media.label));
    //         if (frontCamera) {
    //             setDeviceId(frontCamera.deviceId);
    //         }
    //     }, [setDeviceId]
    // );

    // useEffect(()=>{
    //     navigator.mediaDevices.enumerateDevices().then(handleDevices);
    //   }, [handleDevices]);

    const handleScan = (sresult) => {
        /*    
        if (sresult && sresult.data) {
            if(sresult.data.indexOf('TAMS')>-1){
                const target = sresult.data.replace('TAMS','');
                target !== result.tid && setResult({tid:target});
                // setResult({tno:sresult.data});
            }else{
                setMsg('잘못된 QR CODE입니다.')
            }

        }
        */

        //20251107
        if (sresult && sresult?.text) {
            if(sresult?.text.indexOf('TAMS')>-1){
                const target = sresult?.text.replace('TAMS','');
                target !== result?.tid && setResult({tid:target});
            }else{
                setMsg('잘못된 QR CODE입니다.')
            }
        }
    };

    const handleError = (error) => {
        console.log(error);
    };

    const handleAddSendList = () => {
        if(oRetSt && oRetSt !== ''){
            let temp = (ITEM_STATUS.NORMAL === oRetSt.code || ITEM_STATUS.NO_USE === oRetSt.code) ? {pri_check:false,rel_check:false} : {pri_check:true,rel_check:true}
            const target = {
                ...itemInfo[0],
                id:sendList.length+1,
                sno: param.sno,
                io_st: 'I',
                ret_st: oRetSt,
                ret_st:oRetSt.code,ret_st_nm:oRetSt.nm,
                reg_id: user.uid,
                contents: i_contents,
                descr: i_descr,
                ...temp
            }
            if(inoutHistList.findIndex((item)=>item.tid === itemInfo[0].tid)>-1){
                if(sendList.findIndex((item)=>item.tid === itemInfo[0].tid)<0){
                    queryClient.setQueryData('OPA',{status:true})
                    setSendList([...sendList,target])
                    setMsg('');
                }else{
                    setMsg('이미 추가 되었습니다.');
                }
            }else{
                setMsg('반출 되지 않은 자산입니다.');
            }
        }else{
            setMsg('반입상태를 입력해주세요');
        }
    }

    const handleOutClick = useCallback((sendList) => {
        const sendTarget = {
            mode: 'POST_LIST',
            list: sendList
        }
        mutate(
            sendTarget,
            {
                onSuccess:()=>{
                    navigate(-1);
                    setMsgOpen(false);
                    setRetMsg('');
                    setListOpen(false);
                    setSendList([]);
                }
            }
            )
    });

    const handleConfirm = () => {
        setRetMsg('반입등록 완료 하시겠습니까?');
        setMsgOpen(true);
    }

    const handleClose = (type) => {
        setRetMsg('');
        setMsgOpen(false);
        // setListOpen(false);
        // setSendList([]);
        // if(type==='CLOSE'){
        //     navigate(-1);
        // }
    }

    const handleItemClick = () => {
        setSendList(sendList.filter((item)=> item.tid !== selectItem.tid))
    }

    const rowStatus = (param) => {
        return selectItem && param.row.tid === selectItem.tid && 'selected'
    }

    return (
        <React.Fragment>
            <div style={{padding: '0rem 1rem',display:'flex',alignItems:'center',justifyContent:'flex-start',gap:'8px'}}>
                <img src={`/images/ic_back_arrow.svg`} style={{width:'1.15rem'}} onClick={()=>navigate(-1)}/>
                <NaviText target={[{text:pItem ? pItem[0].iot_nm : ''},{text:'반입'}]} />
            </div>
            <MainWrap>
                <QRWrapper>
                    <img src={`/images/back_qr_radar.svg`} style={{ display: 'block', position: 'absolute', width: 'calc(100% - 8rem)',zIndex:1, opacity:'0.8'}} alt='' />
                    <QrReader
                        // delay={delay}
                        // onError={handleError}
                        // onScan={handleScan}
                        // constraints={{ facingMode: 'environment' }}

                        //20251107
                        scanDelay={delay}
                        onResult={(result, error) => {
                            if (result) handleScan(result);
                            if (error) handleError(error);
                        }}       

                        constraints={{ facingMode: 'environment', advanced: [{ zoom: 3.0 }]  }}
                        videoStyle={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        }}            
                    />
                </QRWrapper>
                {msg && msg}
                {(itemInfo && itemInfo.length > 0) &&
                    <React.Fragment>
                        <Row style={{marginTop:'8px',width:'100%',padding:'1rem 1rem', display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                        <TextField
                                id='tno' 
                                label='자산번호' 
                                size='small' 
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                disabled
                                value={itemInfo && itemInfo[0].tno}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                id='lot_no' 
                                label='표기번호' 
                                size='small' 
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                disabled
                                value={itemInfo && itemInfo[0].lot_no}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                label='구분'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                disabled
                                // placeholder='분류'
                                value={itemInfo && itemInfo[0].pcat_nm}
                            />
                            <TextField
                                label='분류'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                disabled
                                // placeholder='분류'
                                value={itemInfo && itemInfo[0].cat_nm}
                            />
                            <TextField 
                                    id='model_nm' 
                                    label='모델명' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].model_nm}
                                    // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                                />
                            <TextField
                                label='상태'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                disabled
                                // placeholder='분류'
                                value={itemInfo && itemInfo[0].status_nm}
                            />
                        </Row>
                        <Row style={{width:'100%',padding:'0rem 1rem', display:'grid',gap:'4px',gridTemplateColumns:'1fr 1fr 1fr'}}>
                            <FormControl style={{width:'100%'}} size='small'>
                                <InputLabel id='retSt-label'>반입상태</InputLabel>
                                <Select label="반입상태" labelId='retSt-label' size='small' value={oRetSt && oRetSt.code}>
                                    {ioRetStList && ioRetStList.map((item,index)=>{
                                        return <MenuItem 
                                                    key={index} 
                                                    value={item.code} 
                                                    onClick={()=>setORetSt({code:item.code,nm:item.value})}
                                                >
                                                    {item.value}
                                                </MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                            <div style={{display:'flex',justifyContent:'center'}}>
                                <CheckForm
                                    control={
                                        <CheckBox checked={autoIn} onChange={()=>setAutoIn(!autoIn)} name="autoIn" />
                                    }
                                    label="자동담기"
                                    />
                            </div>
                            <Button style={{margin:0,width:'100%',fontSize:'0.9rem'}} onClick={handleAddSendList}>반입대상 담기</Button>
                        </Row>
                        <FoldingBar onClick={setFolidng}/>
                        <Collapse in={folding} style={{width:'100%'}}>
                            <Row style={{width:'100%',padding:'0.5rem 1rem'}}>
                                <TextField 
                                    id='i_contents' 
                                    label='내용' 
                                    fullWidth 
                                    multiline
                                    InputLabelProps={{shrink:true}}  
                                    rows={2} 
                                    size='small' 
                                    value={i_contents}
                                    onChange={(e)=>setI_contents(e.target.value)}
                                />
                            </Row>
                            <Row style={{width:'100%',padding:'0.5rem 1rem 1rem 1rem'}}>
                                <TextField 
                                    id='i_descr' 
                                    label='비고' 
                                    fullWidth 
                                    multiline 
                                    InputLabelProps={{shrink:true}} 
                                    rows={2} 
                                    size='small' 
                                    value={i_descr}
                                    onChange={(e)=>setI_descr(e.target.value)}
                                />
                            </Row>
                        </Collapse>
                    </React.Fragment>
                }
                {(sendList && sendList.length > 0) &&
                    <Fab onClick={()=>setListOpen(true)}>
                        <img src={'/images/ic_up_right_arrow.svg'} alt='' style={{width:'1rem'}} />
                        {sendList.length}
                    </Fab>
                }
            </MainWrap>
            <Drawer 
                open={listOpen}
                onClose={()=>setListOpen(false)}
                anchor={'right'}
            >
                <div style={{padding:'1rem', width:'85vw',maxHeight:'calc(100vh - 2rem)'}}>
                    <h3 style={{margin:0}}>반입 대상 목록</h3>
                    <DrawerInner>
                        <CommonDataGrid
                            // isLoading={itemLoading}
                            list={sendList}
                            columns={columns}
                            showCount={sendList.length}
                            getRowClassName={rowStatus}
                            autoHeight={true}
                            onRowClick={(e)=>{setSelectItem(e.row)}}
                            />
                    </DrawerInner>
                    <Row style={{marginTop:'8px',width:'100%', display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                        <Button onClick={handleItemClick} style={{width:'100%',margin:0,marginTop:'1rem'}}>목록에서빼기</Button>
                        <Button onClick={handleConfirm} style={{width:'100%',margin:0,marginTop:'1rem'}}>반입완료</Button>
                    </Row>
                </div>
            </Drawer>
            <MobileMsgModal open={msgOpen}>
                <div>
                    <h3 style={{margin:0}}>{retMsg}</h3>
                    <Row style={{width:'100%',display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                    <Button onClick={handleClose}>취소</Button>
                        <Button onClick={()=>handleOutClick(sendList)}>확인</Button>
                        {/* <Button onClick={()=>handleClose('NEXT')}>계속</Button>
                        <Button onClick={()=>handleClose('CLOSE')}>완료</Button> */}
                    </Row>
                </div>
            </MobileMsgModal>
        </React.Fragment>
    )
}

export default InControl;